import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pdfPageNumber',
  standalone: true,
})
export class PdfPageNumberPipe implements PipeTransform {
  transform(page: number | [number, number]): number {
    if (Array.isArray(page)) {
      page = page[0];
    }
    return Number(page) + 1;
  }
}
